import { Button } from "carbon-components-react";

// eslint-disable-next-line
export default (props) => {
  return <Button {...props}>{props.children}</Button>;
};
